import * as React from 'react'
import AnimateHeight from 'react-animate-height'
import './PetDrawer.css'
// import { useSwipeable } from 'react-swipeable'
import { useSnapshot } from 'valtio'
import { drawerState } from '../../store/drawerState.ts'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClose } from '@fortawesome/free-solid-svg-icons'
import { clearRoute } from '../map/Directions/directionHelper.tsx'
import { mapState } from '../../store/mapState.ts'

// const getVal = (px: string) => parseInt(px.split('px')[0])
// const heightPresets = [20, 80, 160, 240, 330, 400]
export const PetDrawer: React.FC = () => {
    const height = useSnapshot(drawerState).drawerSize
    const children = useSnapshot(drawerState).children as React.ReactNode
    const travelMode = (useSnapshot(mapState) as typeof mapState).travelMode

    return (
        <div>
            <AnimateHeight
                id="pet-drawer"
                duration={500}
                height={height as any}
                className={'w-[100vw] max-h-[88vh] overflow-y-auto pointer-events-auto'}
            >
                <div className={'bg-transparent h-auto min-h-[100px] pb-[12vh]'}>
                    {children}
                    {drawerState.children === null ? (
                        <div id="directions-header" className={'w-full flex flex-row justify-between items-center border-b-2 border-b-primary mb-2'}>
                            <div className={'p-2 text-md font-semibold text-primary'}>
                                {travelMode} Directions
                            </div>
                            <div
                                className={'pr-4 cursor-pointer'}
                                onClick={() => clearRoute()}>
                                <FontAwesomeIcon icon={faClose} fontSize={'medium'} size={'lg'}/>
                            </div>
                        </div>
                    ) : null}
                </div>
            </AnimateHeight>
        </div>
    )
}
